import { SALE_COLOR_COPY_CHANGE_241030 } from "@faire/web-api--source/indigofair/settings/SALE_COLOR_COPY_CHANGE_241030";

import { getSettingValueAndAssign } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingAndAssignUpdateSaleColorCopy = () =>
  getSettingValueAndAssign(SALE_COLOR_COPY_CHANGE_241030, false);
